import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FieldComponent } from 'ngx-smart-form/lib/smart-form/interfaces/field-component';
import { SharedModule } from '../../../_shared/shared.module';
import { EditableField } from '../editable-field';

@Component({
  selector: 'app-editable-field',
  templateUrl: './editable-field.component.html',
  styleUrls: ['./editable-field.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class EditableFieldComponent implements FieldComponent {
  formControl!: FormControl;
  field?: EditableField;

  readonly = true;

  setFieldInfo(field: EditableField) {
    this.formControl = field.controlRef as FormControl;
    this.field = field;
  }
}
